{
  "appName": "Աշխատակիցների կառավարման հարթակ",
  "actions": {
    "save": "Պահպանել",
    "saving": "Պահպանվում է…",
    "cancel": "Չեղարկել",
    "delete": "Ջնջել",
    "deleting": "Ջնջվում է…",
    "edit": "Խմբագրել",
    "create": "Ստեղծել",
    "retry": "Կրկին փորձել",
    "refresh": "Թարմացնել",
    "export": "Արտահանել",
    "dismiss": "Փակել",
    "done": "Պատրաստ",
    "restore": "Վերականգնել",
    "restoring": "Վերականգնվում է…",
    "signOut": "Դուրս գալ",
    "changePassword": "Փոխել գաղտնաբառը",
    "activate": "Ակտիվացնել",
    "activating": "Ակտիվացվում է…",
    "deactivate": "Ապաակտիվացնել",
    "deactivating": "Ապաակտիվացվում է…",
    "copy": "Պատճենել",
    "upload": "Բեռնել",
    "uploading": "Բեռնվում է…",
    "approve": "Հաստատել",
    "approving": "Հաստատվում է…",
    "reject": "Մերժել",
    "rejecting": "Մերժվում է…",
    "openMenu": "Բացել ընտրացանկը",
    "closeMenu": "Փակել ընտրացանկը",
    "openUserMenu": "Բացել օգտատիրոջ ընտրացանկը",
    "language": "Լեզու",
    "selectLanguage": "Ընտրել լեզուն",
    "selectAll": "Ընտրել բոլորը",
    "close": "Փակել",
    "backToHome": "Գլխավոր էջ"
  },
  "aria": {
    "loadingApplication": "Հավելվածը բեռնվում է",
    "loading": "Բեռնվում է…",
    "searchEmployees": "Որոնել աշխատակիցներ"
  },
  "status": {
    "active": "Ակտիվ",
    "inactive": "Ոչ ակտիվ",
    "deleted": "Ջնջված"
  },
  "table": {
    "name": "Անուն",
    "description": "Նկարագրություն",
    "status": "Կարգավիճակ",
    "actions": "Գործողություններ",
    "email": "Էլ. հասցե",
    "role": "Դեր",
    "date": "Ամսաթիվ",
    "note": "Նշում",
    "noData": "Տվյալ չկա",
    "failedToLoad": "Չհաջողվեց բեռնել",
    "created": "Ստեղծված"
  },
  "pagination": {
    "previous": "Նախորդ",
    "next": "Հաջորդ",
    "pageOf": "Էջ {{current}} / {{total}}",
    "records": "Գրառումներ՝",
    "previousPage": "Նախորդ էջ",
    "nextPage": "Հաջորդ էջ"
  },
  "filters": {
    "from": "Սկսած",
    "to": "Մինչև",
    "search": "Որոնել...",
    "clearFilters": "Մաքրել ֆիլտրերը",
    "allEmployees": "Բոլոր աշխատակիցները",
    "employee": "Աշխատակից",
    "timeRange": "Ժամանակահատված"
  },
  "form": {
    "optional": "(կամընտիր)",
    "unassigned": "(Չնշանակված)",
    "active": "Ակտիվ"
  },
  "errors": {
    "unexpectedError": "Անսպասելի սխալ է տեղի ունեցել: Խնդրում ենք կրկին փորձել:",
    "saveFailed": "Չհաջողվեց պահպանել",
    "loadFailed": "Չհաջողվեց բեռնել տվյալները: Խնդրում ենք կրկին փորձել:",
    "connectionError": "Ստուգեք կապը և կրկին փորձեք:"
  },
  "nav": {
    "mainNavigation": "Գլխավոր նավիգացիա",
    "platformNavigation": "Հարթակի նավիգացիա"
  }
}
